import { useState } from "react";
import locale from "locales";
import { trackSignUp, trackEmailAddress } from "helpers/analytics";
import hashEmailAddress from "helpers/hash-email-address";

const useNewsletterSubscribe = (id, handle) => {
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubscribe = async () => {
    window.grecaptcha.ready(async function () {
      await window.grecaptcha.execute(process.env.GATSBY_RECAPTCHA_SITE_KEY, { action: "submit" });

      if (invalidEmail(email)) {
        setError(locale.footer.validEmail);
        return;
      }

      try {
        const response = await fetch("/.netlify/functions/klaviyo", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email, listId: id
          }),
        });

        if (response?.status === 204) {
          setSubmitted(locale.account.waitingList.joinedWaitingList);
          if (handle) {
            window.location.href = handle;
          }
        } else {
          const serverResponse = await response.json();
          setError(serverResponse.error);
        }
      } catch (err) {
        console.log({ err });
        setError("Use netlify");
      }
    });

    trackSignUp("newsletter", "email address");
    const hashedEmail = await hashEmailAddress(email);
    trackEmailAddress(hashedEmail);
  };

  const onEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const invalidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !emailRegex.test(email);
  };

  return {
    submitted,
    error,
    invalidEmail,
    handleSubscribe,
    onEmailChange
  };
};

export default useNewsletterSubscribe;
